var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"intro full-fixed bg-beige overflow-hidden"},[_c('div',{ref:"introSvg",staticClass:"w-100 position-absolute intro-svg",style:(_vm.introSvgStyle),domProps:{"innerHTML":_vm._s(_vm.IntroSvg)}})])}
var staticRenderFns = []

export { render, staticRenderFns }